import { PropsWithChildren } from "react";
import Form from "../components/forms/Form";
import Footer from "../components/footer/Footer";
import EditorTracker, {
  EditorAction
} from "../components/editor/EditorTracker";
import useEditorSections from "../components/editor/useEditorSections";
import { FieldValues } from "react-hook-form";

const ReportEditorLayout = <T extends FieldValues>({
  defaultValues,
  actions,
  children,
  onSubmit
}: PropsWithChildren<{
  defaultValues: T;
  actions: EditorAction<T>[];
  onSubmit: (data: T) => void;
}>) => {
  const sections = useEditorSections(children);

  return (
    <div className="flex h-full flex-col bg-ctb-grey-250">
      <Form
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        className="grid flex-grow grid-cols-1 gap-20 pb-20 pl-8 pr-12 xl:grid-cols-[auto_15rem]"
        defaultErrorDisplay={false}
      >
        <section className="flex flex-col gap-12 pt-6">{children}</section>
        <EditorTracker actions={actions} sections={sections} />
      </Form>
      <Footer />
    </div>
  );
};

export default ReportEditorLayout;


